/* eslint-disable no-spaced-func */
/* eslint-disable @typescript-eslint/indent */
import { PersonType } from 'API';
import { createContext } from 'react';
import { Updater } from 'use-immer';

export const ProfileContext = createContext<
  [
    Person | null,
    Updater<Person | null>,
    PersonType | undefined,
      ]
      >([null,
        () => { },
        undefined]);

export default ProfileContext;
